/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAssociation = /* GraphQL */ `
  mutation CreateAssociation(
    $input: CreateAssociationInput!
    $condition: ModelAssociationConditionInput
  ) {
    createAssociation(input: $input, condition: $condition) {
      id
      name
      url
      address
      location
      email
      phone
      image {
        bucket
        region
        key
      }
      users {
        items {
          id
          unit
          role
          title
          createdAt
          updatedAt
        }
        nextToken
      }
      invites {
        items {
          id
          firstName
          lastName
          email
          role
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`
export const updateAssociation = /* GraphQL */ `
  mutation UpdateAssociation(
    $input: UpdateAssociationInput!
    $condition: ModelAssociationConditionInput
  ) {
    updateAssociation(input: $input, condition: $condition) {
      id
      name
      url
      address
      location
      email
      phone
      image {
        bucket
        region
        key
      }
      users {
        items {
          id
          unit
          role
          title
          createdAt
          updatedAt
        }
        nextToken
      }
      invites {
        items {
          id
          firstName
          lastName
          email
          role
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`
export const deleteAssociation = /* GraphQL */ `
  mutation DeleteAssociation(
    $input: DeleteAssociationInput!
    $condition: ModelAssociationConditionInput
  ) {
    deleteAssociation(input: $input, condition: $condition) {
      id
      name
      url
      address
      location
      email
      phone
      image {
        bucket
        region
        key
      }
      users {
        items {
          id
          unit
          role
          title
          createdAt
          updatedAt
        }
        nextToken
      }
      invites {
        items {
          id
          firstName
          lastName
          email
          role
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`
export const createAssociationsUsers = /* GraphQL */ `
  mutation CreateAssociationsUsers(
    $input: CreateAssociationsUsersInput!
    $condition: ModelAssociationsUsersConditionInput
  ) {
    createAssociationsUsers(input: $input, condition: $condition) {
      id
      unit
      role
      title
      user {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
        associations {
          nextToken
        }
        createdAt
        updatedAt
      }
      association {
        id
        name
        url
        address
        location
        email
        phone
        image {
          bucket
          region
          key
        }
        users {
          nextToken
        }
        invites {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`
export const updateAssociationsUsers = /* GraphQL */ `
  mutation UpdateAssociationsUsers(
    $input: UpdateAssociationsUsersInput!
    $condition: ModelAssociationsUsersConditionInput
  ) {
    updateAssociationsUsers(input: $input, condition: $condition) {
      id
      unit
      role
      title
      user {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
        associations {
          nextToken
        }
        createdAt
        updatedAt
      }
      association {
        id
        name
        url
        address
        location
        email
        phone
        image {
          bucket
          region
          key
        }
        users {
          nextToken
        }
        invites {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`
export const deleteAssociationsUsers = /* GraphQL */ `
  mutation DeleteAssociationsUsers(
    $input: DeleteAssociationsUsersInput!
    $condition: ModelAssociationsUsersConditionInput
  ) {
    deleteAssociationsUsers(input: $input, condition: $condition) {
      id
      unit
      role
      title
      user {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
        associations {
          nextToken
        }
        createdAt
        updatedAt
      }
      association {
        id
        name
        url
        address
        location
        email
        phone
        image {
          bucket
          region
          key
        }
        users {
          nextToken
        }
        invites {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`
export const createUser = /* GraphQL */ `
  mutation CreateUser($input: CreateUserInput!, $condition: ModelUserConditionInput) {
    createUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      phone
      avatar {
        bucket
        region
        key
      }
      associations {
        items {
          id
          unit
          role
          title
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($input: UpdateUserInput!, $condition: ModelUserConditionInput) {
    updateUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      phone
      avatar {
        bucket
        region
        key
      }
      associations {
        items {
          id
          unit
          role
          title
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser($input: DeleteUserInput!, $condition: ModelUserConditionInput) {
    deleteUser(input: $input, condition: $condition) {
      id
      firstName
      lastName
      email
      phone
      avatar {
        bucket
        region
        key
      }
      associations {
        items {
          id
          unit
          role
          title
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`
export const createInvite = /* GraphQL */ `
  mutation CreateInvite($input: CreateInviteInput!, $condition: ModelInviteConditionInput) {
    createInvite(input: $input, condition: $condition) {
      id
      email
      role
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
        createdAt
      }
      createdAt
      association {
        id
        name
      }
    }
  }
`
export const updateInvite = /* GraphQL */ `
  mutation UpdateInvite($input: UpdateInviteInput!, $condition: ModelInviteConditionInput) {
    updateInvite(input: $input, condition: $condition) {
      id
      email
      role
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
        createdAt
      }
      createdAt
      association {
        id
        name
      }
    }
  }
`
export const deleteInvite = /* GraphQL */ `
  mutation DeleteInvite($input: DeleteInviteInput!, $condition: ModelInviteConditionInput) {
    deleteInvite(input: $input, condition: $condition) {
      id
      email
      role
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
        createdAt
      }
      createdAt
      association {
        id
        name
      }
    }
  }
`
export const createDocument = /* GraphQL */ `
  mutation CreateDocument($input: CreateDocumentInput!, $condition: ModelDocumentConditionInput) {
    createDocument(input: $input, condition: $condition) {
      id
      associationId
      title
      content
      files {
        items {
          id
          associationId
          title
          createdAt
          updatedAt
        }
        nextToken
      }
      type
      createdAt
      updatedAt
    }
  }
`
export const updateDocument = /* GraphQL */ `
  mutation UpdateDocument($input: UpdateDocumentInput!, $condition: ModelDocumentConditionInput) {
    updateDocument(input: $input, condition: $condition) {
      id
      associationId
      title
      content
      files {
        items {
          id
          associationId
          title
          createdAt
          updatedAt
        }
        nextToken
      }
      type
      createdAt
      updatedAt
    }
  }
`
export const deleteDocument = /* GraphQL */ `
  mutation DeleteDocument($input: DeleteDocumentInput!, $condition: ModelDocumentConditionInput) {
    deleteDocument(input: $input, condition: $condition) {
      id
      associationId
      title
      content
      files {
        items {
          id
          associationId
          title
          createdAt
          updatedAt
        }
        nextToken
      }
      type
      createdAt
      updatedAt
    }
  }
`
export const createFile = /* GraphQL */ `
  mutation CreateFile($input: CreateFileInput!, $condition: ModelFileConditionInput) {
    createFile(input: $input, condition: $condition) {
      id
      associationId
      file {
        bucket
        region
        key
      }
      parentId
      title
      createdAt
      updatedAt
      owner
    }
  }
`
export const updateFile = /* GraphQL */ `
  mutation UpdateFile($input: UpdateFileInput!, $condition: ModelFileConditionInput) {
    updateFile(input: $input, condition: $condition) {
      id
      associationId
      file {
        bucket
        region
        key
      }
      parentId
      title
      createdAt
      updatedAt
      owner
    }
  }
`
export const deleteFile = /* GraphQL */ `
  mutation DeleteFile($input: DeleteFileInput!, $condition: ModelFileConditionInput) {
    deleteFile(input: $input, condition: $condition) {
      id
      associationId
      file {
        bucket
        region
        key
      }
      parentId
      title
      createdAt
      updatedAt
      owner
    }
  }
`
export const createShare = /* GraphQL */ `
  mutation CreateShare($input: CreateShareInput!, $condition: ModelShareConditionInput) {
    createShare(input: $input, condition: $condition) {
      id
      associationId
      email
      content
      types
      createdAt
      updatedAt
    }
  }
`
export const updateShare = /* GraphQL */ `
  mutation UpdateShare($input: UpdateShareInput!, $condition: ModelShareConditionInput) {
    updateShare(input: $input, condition: $condition) {
      id
      associationId
      email
      content
      types
      createdAt
      updatedAt
    }
  }
`
export const deleteShare = /* GraphQL */ `
  mutation DeleteShare($input: DeleteShareInput!, $condition: ModelShareConditionInput) {
    deleteShare(input: $input, condition: $condition) {
      id
      associationId
      email
      content
      types
      createdAt
      updatedAt
    }
  }
`

export const createMessage = /* GraphQL */ `
  mutation CreateMessage($input: CreateMessageInput!, $condition: ModelMessageConditionInput) {
    createMessage(input: $input, condition: $condition) {
      id
      associationId
      content
      createdAt
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
      }
      updatedAt
      owner
      files {
        items {
          id
          associationId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage($input: UpdateMessageInput!, $condition: ModelMessageConditionInput) {
    updateMessage(input: $input, condition: $condition) {
      id
      associationId
      content
      createdAt
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
      }
      updatedAt
      owner
      files {
        items {
          id
          associationId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage($input: DeleteMessageInput!, $condition: ModelMessageConditionInput) {
    deleteMessage(input: $input, condition: $condition) {
      id
      associationId
      content
      createdAt
      author {
        id
        firstName
        lastName
        email
        phone
        avatar {
          bucket
          region
          key
        }
      }
      updatedAt
      owner
      files {
        items {
          id
          associationId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`
export const createDisclosure = /* GraphQL */ `
  mutation CreateDisclosure(
    $input: CreateDisclosureInput!
    $condition: ModelDisclosureConditionInput
  ) {
    createDisclosure(input: $input, condition: $condition) {
      id
      associationId
      unit
      haveLiens
      liensDescription
      reservesAmount
      haveCapitalExpenditures
      capitalExpendituresType
      capitalExpendituresOther
      haveSpecialAssessment
      specialAssessmentAmount
      haveIncreaseMonthly
      increaseMonthlyAmount
      increaseMonthlyEndDate
      haveCompliantAlterations
      compliantAlterationsDescription
      haveLawsuits
      lawsuitsDescription
      insuranceName
      insuranceAddress
      insuranceContactName
      insurancePhone
      insuranceEmail
      asssessmentAmount
      unpaidAssessmentAmount
      contactEmail
      preparedByName
      preparedDate
      createdAt
      updatedAt
      latestFinancials {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestBudget {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestMinutes {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      owner
    }
  }
`
export const updateDisclosure = /* GraphQL */ `
  mutation UpdateDisclosure(
    $input: UpdateDisclosureInput!
    $condition: ModelDisclosureConditionInput
  ) {
    updateDisclosure(input: $input, condition: $condition) {
      id
      associationId
      unit
      haveLiens
      liensDescription
      reservesAmount
      haveCapitalExpenditures
      capitalExpendituresType
      capitalExpendituresOther
      haveSpecialAssessment
      specialAssessmentAmount
      haveIncreaseMonthly
      increaseMonthlyAmount
      increaseMonthlyEndDate
      haveCompliantAlterations
      compliantAlterationsDescription
      haveLawsuits
      lawsuitsDescription
      insuranceName
      insuranceAddress
      insuranceContactName
      insurancePhone
      insuranceEmail
      asssessmentAmount
      unpaidAssessmentAmount
      contactEmail
      preparedByName
      preparedDate
      createdAt
      updatedAt
      latestFinancials {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestBudget {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestMinutes {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      owner
    }
  }
`
export const deleteDisclosure = /* GraphQL */ `
  mutation DeleteDisclosure(
    $input: DeleteDisclosureInput!
    $condition: ModelDisclosureConditionInput
  ) {
    deleteDisclosure(input: $input, condition: $condition) {
      id
      associationId
      unit
      haveLiens
      liensDescription
      reservesAmount
      haveCapitalExpenditures
      capitalExpendituresType
      capitalExpendituresOther
      haveSpecialAssessment
      specialAssessmentAmount
      haveIncreaseMonthly
      increaseMonthlyAmount
      increaseMonthlyEndDate
      haveCompliantAlterations
      compliantAlterationsDescription
      haveLawsuits
      lawsuitsDescription
      insuranceName
      insuranceAddress
      insuranceContactName
      insurancePhone
      insuranceEmail
      asssessmentAmount
      unpaidAssessmentAmount
      contactEmail
      preparedByName
      preparedDate
      createdAt
      updatedAt
      latestFinancials {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestBudget {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      latestMinutes {
        id
        associationId
        title
        content
        type
        createdAt
        updatedAt
        owner
        files {
          nextToken
        }
      }
      owner
    }
  }
`
